// extracted by mini-css-extract-plugin
export default {"image":"PosDepositDialog_image__9BLfx","content":"PosDepositDialog_content__Q+I2I","title":"PosDepositDialog_title__EZKSi"};